import { useCallback } from 'react';
import type { HeaderCarousel } from 'types/capi/modules';

import SplashSlideImpressionEvent from '~/events/SplashSlideImpressionEvent';
import type { SplashSlideModuleType } from '~/events/SplashSlideInteractionEvent';
import useImpression from '~/hooks/useImpression';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

type Options = {
  modulePosition?: number;
  moduleType: SplashSlideModuleType;
  position: number;
  slide?: HeaderCarousel['items'][0];
};

// Once per slide per view, when the slide itself is viewable: a carousel clips the slides it is
// not showing, so each is counted as it scrolls in and a looping carousel does not inflate them.
export default function useSplashSlideImpression<T extends HTMLElement>({
  modulePosition,
  moduleType,
  position,
  slide
}: Options) {
  const { isBot } = useRootData();
  const { guestId } = useUser();

  const track = useCallback(() => {
    if (!slide) return;

    new SplashSlideImpressionEvent({
      guestId,
      isBot,
      modulePosition,
      moduleType,
      position,
      slide
    }).track();
  }, [guestId, isBot, modulePosition, moduleType, position, slide]);

  return useImpression<T>(track, { enabled: !isBot && !!slide });
}
